import { LogisticaConfigurationProvider } from "./components/logistica/configurazione/LogisticaConfigurationProvider";
import LogisticaConfigurationPage from "./components/logistica/configurazione/LogisticaConfigurationPage";
import ControlloMagazzino from "./components/logistica/magazzino/ControlloMagazzino";
import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import "./App.css";
import { useAuth0 } from "@auth0/auth0-react";
import { Navigate, Routes, Route /* , useParams */ } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import AreaCSVupload from "./components/importCSV/AreaCSVupload";
import prodVuoto from "./components/prodottoVuoto";
import apiUrl from "./components/Apiurl";
import DBconTraduzioniERicicla from "./components/navigadbsections/navigaDBsubMenu/DBconTraduzioniERicicla";
import DBconSchedaProd from "./components/navigadbsections/navigaDBsubMenu/DBconSchedaProd";
import MenuPStools from "./components/ps-tools/creaUrlCategorieMenu2/MenuPStools";
import DBToolsMenu from "./components/db-tools/DBToolsMenu";
import UIProdottoDBCrea from "./components/modificaProdotti/UIProdottoDBCrea";
import AreaLogisticaOffline from "./components/logistica/AreaLogisticaOffline";
import AreaLogisticaBeta from "./components/logistica/AreaLogisticaBeta";
import AreaSparaTrovati from "./components/logistica/AreaSparaTrovati";
import Layout from "./components/interfaccia/menu/Layout";
import ExportCSV from "./components/exportCSV/ExportCSV";
import CorreggiUtenti from "./components/db-tools/CorreggiUtenti";
import UIultimeModificheOCrea from "./components/statistiche/UIultimeModificheOCrea";
import Impostazioni from "./components/Impostazioni";
import AreaOrdiniPRE from "./components/logistica/AreaOrdiniPRE";
import CreaHTMLCampagne from "./components/ps-tools/htmlCampagne/CreaHTMLCampagne";
import AreaProblemiPS from "./components/problemiPS/AreaProblemiPS";
import AreaproblemiDB from "./components/problemiDB/AreaproblemiDB";
import AreaTraduzioniFromPS from "./components/traduzioniFromPS/AreaTraduzioniFromPS";
import AreaAnteprimaExport from "./components/anteprimaExport/AreaAnteprimaExport";
import Inventario from "./components/magazzino/inventario/Inventario";
import ContainerBarraELista from "./components/contabilita/ContainerBarraELista";
import ControlloCorrispettiviAmazon from "./components/contabilita/ControlloCorrispettiviAmazon";
import ControlloCorrispettiviPrestashop from "./components/contabilita/ControlloCorrispettiviPrestashop";
import ControlloCorrispettiviGestionale from "./components/contabilita/ControlloCorrispettiviGestionale";
import ControlliCorrispettivi from "./components/contabilita/ControlliCorrispettivi";
import RiepilogoCorrispettiviConfermati from "./components/contabilita/RiepilogoCorrispettiviConfermati";
import TransazioniDominoCorrispettivi from "./components/contabilita/TransazioniDominoCorrispettivi";
import DashboardDAM from "./components/statistiche/DashboardDAM";
import AreaCheckSparati from "./components/logistica/AreaCheckSparati";
import AreaDashboard from "./components/dashboard/AreaDashboard";
import AnaLogistica from "./components/anagrafiche/logistica/AnaLogistica";
import ModificaMassivaDatiConSync from "./components/db-tools/ModificaMassivaDatiConSync";
import HomeNuovoUtente from "./components/interfaccia/pagine/HomeNuovoUtente";
import UIComponentsPage from "./components/interfaccia/pagine/UIComponentsPage";
import UISkeletonDocsPage from "./components/interfaccia/pagine/UISkeletonDocsPage";
import EnvironmentVariablesPage from "./components/interfaccia/pagine/EnvironmentVariablesPage";
import LogisticaAutomationRulesPage from "./components/interfaccia/pagine/LogisticaAutomationRulesPage";
import StatSpedCorrieri from "./components/statistiche/StatSpedCorrieri";
import StatSpedMarketplaces from "./components/statistiche/StatSpedMarketplaces";
import StatSpedAnni from "./components/statistiche/StatSpedAnni";
import StatSpedMotiviAnnullamenti from "./components/statistiche/StatSpedMotiviAnnullamenti";
import MenuMobile from "./components/interfaccia/menu/MenuMobile";
import Consultazione from "./components/terminalini/Consultazione";
import RoutineMattutina from "./components/logistica/routineMattutina/RoutineMattutina";
import DashboardOrdini from "./components/logistica/DashboardOrdini/DashboardOrdini";
import ModaArticoliWorkspace from "./components/moda/ModaArticoliWorkspace";
import MatchBotteroPage from "./components/moda/MatchBotteroPage";
import MatchBotteroReadOnlyPage from "./components/moda/MatchBotteroReadOnlyPage";
import MatchBotteroStatsPage from "./components/moda/MatchBotteroStatsPage";
import MatchBotteroVsSidePage from "./components/moda/MatchBotteroVsSidePage";
import PrestashopAlignmentPage from "./components/moda/PrestashopAlignmentPage";
import PrioritaBrandPage from "./components/moda/PrioritaBrandPage";
import StatsPubblBrandPage from "./components/moda/StatsPubblBrandPage";
import DashboardPubblicazioni from "./components/moda/DashboardPubblicazioni";
import PrestashopCategoriesPage from "./components/moda/PrestashopCategoriesPage";
import WebCategoryAttributeRulesPage from "./components/moda/WebCategoryAttributeRulesPage";
import WebCategoryMappingValuesPage from "./components/moda/WebCategoryMappingValuesPage";
import RimozioneMassivaCategorieDB from "./components/db-tools/RimozioneMassivaCategorieDB";
import AggiuntaMassivaCategorieDB from "./components/db-tools/AggiuntaMassivaCategorieDB";
import SyncImmagini from "./components/ps-tools/syncImmagini/SyncImmagini";
import PubbWeekManual from "./components/db-tools/PubbWeekManual";
import ModaBulkJobsPage from "./components/db-tools/ModaBulkJobsPage";
import TraduzioniPage from "./components/traduzioni/TraduzioniPage";
import DashboardImmaginiJobsPage from "./components/db-tools/DashboardImmaginiJobsPage";
import R2ImagesDashboardPage from "./components/db-tools/R2ImagesDashboardPage";
import HeaderMessageMaintenancePage from "./components/interfaccia/headerMessage/HeaderMessageMaintenancePage";
import EanToCodvsPage from "./components/db-tools/EanToCodvsPage";
import { loadTranslationQuota, translationAllowed } from "./components/traduzioni/translationQuota";

function App({ autenticazione }) {
  //TODO: lasciare token e setToken a questo livello e passarli come parametri a tutti i componenti figli, togliere tutte le robe di auth da tutti i componenti

  //TODO: spostare le chiamate charcount in un posto più appropriato di questo

  const [traduzione, setTraduzione] = useState({
    prodottoCorrente: prodVuoto,
    descDaValutareIT: false,
  });
  const [listaNomiProdotto, setListaNomiProdotto] = useState([]);
  const [token, setToken] = useState("");
  const { user, /* isAuthenticated,  */ getAccessTokenSilently } = useAuth0();
  const [temaColori, setTemaColori] = useState(
    autenticazione.tema || "rootTema",
  );
  const [magCheck, setMagCheck] = useState("Prato Nevoso");

  useEffect(() => {
    const interceptor = axios.interceptors.request.use((config) => {
      const method = String(config?.method || "get").toLowerCase();
      const isWrite = ["post", "put", "patch", "delete"].includes(method);
      const requestUrl = String(config?.url || "");
      const configuredApiUrl = String(apiUrl || "").trim();
      const isDominoApiRequest =
        (configuredApiUrl && requestUrl.startsWith(configuredApiUrl)) ||
        requestUrl.startsWith("/");

      if (!isWrite || !isDominoApiRequest) {
        return config;
      }

      const username =
        typeof autenticazione?.username === "string"
          ? autenticazione.username.trim()
          : "";
      if (!username || /^[A-Za-z0-9._-]+\|/.test(username)) {
        return Promise.reject(
          new Error(
            "Username Domino mancante nell'oggetto autenticazione: operazione non inviata.",
          ),
        );
      }

      config.headers = config.headers || {};
      config.headers["X-Domino-Username"] = username;
      return config;
    });

    return () => axios.interceptors.request.eject(interceptor);
  }, [autenticazione?.username]);

  const mobile = useMediaQuery({
    query: "(max-width:400px),(orientation: portrait)",
  });
  const inputVuoto = {
    "a.`Cod Viglietti Sport` LIKE": "",
    "a.`Codice EAN` LIKE": "",
    "a.`Produttore` LIKE": "",
    ricercaRapidaOrdini: "",
    "sped.nomeCliente LIKE": "",
    "sped.Stato_Ordine =": "",
    statoModaOrdine: "",
    "sped.N_rif_PrestaShop LIKE": "",
    "sped.N_rif_MarketPlace LIKE": "",
    "sped.N_Trakking LIKE": "",
    "sped.Data_partenza =": "",
    "sped.Promemoria =": "",
    "sped.Tipo_di_pagamento =": "",
    "sped.Corriere IN": "",
    "sped.Partenza_da =": "",
    "sped.Emissione_scontrino IN": "",
    "statoMag.stato LIKE": "",
    "sped.N_rif_PrestaShop >=": "",
    "sped.N_rif_PrestaShop <=": "",
    "sped.Data_partenza >=": "",
    "sped.Data_partenza <=": "",
    dataStart: "",
    dataEnd: "",
    "a.trovato IS": "",
  };

  const objRicercheRapideDBOrdini = {
    tutti: {
      ...inputVuoto,
    },
    parteDaTorino: {
      ...inputVuoto,
      "sped.Partenza_da =": "Torino",
    },
    parteOggiDaPrato: {
      ...inputVuoto,
      "sped.Data_partenza =": new Date().toISOString(),
      "sped.Partenza_da =": "Prato Nevoso",
    },
    promemoria: {
      ...inputVuoto,
      "sped.Promemoria =": "1",
    },
    contrassegniOggi: {
      ...inputVuoto,
      "sped.Data_partenza =": new Date(),
      "sped.Tipo_di_pagamento =": "Contrassegno",
    },
    scontriniNO: {
      ...inputVuoto,
      "sped.Emissione_scontrino NOT IN": "SI",
    },
  };

  function toDate(stringDate) {
    if (stringDate) {
      var d = new Date(stringDate),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    } else {
      return null;
    }
  }

  function firstDayInPreviousMonth(yourDate) {
    return new Date(yourDate.getFullYear(), yourDate.getMonth() - 1, 1);
  }

  function dateLastMonth() {
    var date = new Date();
    date.setDate(0);
    return date;
  }

  //DATE UTILI
  const oggi = new Date();
  const oggiString = oggi; /* .toISOString() */
  const dataDaMod = new Date();
  const trentaGiorniFa = dataDaMod.setDate(dataDaMod.getDate() - 30);
  const trentaGiorniFaString = new Date(trentaGiorniFa); /* .toISOString() */
  const inizioMeseScorso = firstDayInPreviousMonth(oggi);
  const fineMeseScorso = dateLastMonth();

  const [inputCont, setInputCont] = useState({
    dataStart: toDate(inizioMeseScorso),
    dataEnd: toDate(fineMeseScorso),
  });

  const objRicercheRapideContabili = {
    //DEVONO AVERE DATASTART E DATAEND
    tutti: {
      ...inputVuoto,
    },
    ultimi30giorni: {
      ...inputVuoto,
      dataStart: trentaGiorniFaString,
      dataEnd: oggiString,
    },
  };

  useEffect(() => {
    setTemaColori(autenticazione.tema);
  }, [autenticazione]);

  /// RIQUADRO STATS TRADUZIONI E BLOCCO TRADUZIONI DA INTEGRARE IN QUALCHE ALTRO MODO

  const [charCount, setCharCount] = useState(0);
  const [charLimit, setCharLimit] = useState(null);
  const [charCountLoading, setCharCountLoading] = useState(true);
  const [charCountError, setCharCountError] = useState(false);
  const [tradPermessa, setTradPermessa] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    setCharCountLoading(true);
    setCharCountError(false);
    setTradPermessa(false);
    loadTranslationQuota(getAccessTokenSilently, controller.signal)
      .then(({ total, limit }) => {
        if (controller.signal.aborted) return;
        setCharCount(total);
        setCharLimit(limit);
        setTradPermessa(translationAllowed(total, limit));
      })
      .catch((error) => {
        if (controller.signal.aborted) return;
        console.error("Errore nel conteggio caratteri", error);
        setCharCountError(true);
        setTradPermessa(false);
      })
      .finally(() => {
        if (!controller.signal.aborted) setCharCountLoading(false);
      });
    return () => controller.abort();
  }, [getAccessTokenSilently, user?.sub]);

  useEffect(() => {
    if (!token) {
      console.warn("sto aspettando un token");
      return;
    }
    fetch(apiUrl + "/prodotti/get/names", {
      headers: { Authorization: "Bearer " + token },
    })
      .then((resp) => resp.json())
      .then((data) => setListaNomiProdotto(data));
  }, [token]);

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };
    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  const setProductFunction = useCallback((prod) => {
    setTraduzione((prev) => ({
      ...prev,
      prodottoCorrente: prod,
    }));
  }, []);

  /////// AREE PRINCIPALI //////////

  const areaOrdini = (
    <AreaOrdiniPRE
      vistaINIT="ordini"
      utente={autenticazione}
      ricercaIniz={objRicercheRapideDBOrdini.tutti}
      tema={temaColori}
      urlRicercaINIT={
        apiUrl + "/logistica/ricerca/ricercaOrdiniDBavanzataPagination/"
      }
      perPageINIT={200}
      inputVuoto={inputVuoto}
      keyArea="1"
      mobile={mobile}
    />
  );

  const dashboardOrdini = (
    <DashboardOrdini
      token={token}
      mobile={mobile}
      temaColori={temaColori}
      utente={autenticazione}
      inputCont={inputCont}
      setInputCont={setInputCont}
    />
  );

  const areaPubblicazione = (
    <ModaArticoliWorkspace
      token={token}
      utente={autenticazione}
      mobile={mobile}
      temaColori={temaColori}
      setProductFunction={setProductFunction}
      listaNomiProdotto={listaNomiProdotto}
    />
  );

  const areaPubblicazioneConsultazione = (
    <UIProdottoDBCrea
      product={traduzione.prodottoCorrente}
      setProductFunction={setProductFunction}
      utente={autenticazione}
      tradPermessa={tradPermessa}
      charCount={charCount}
      listaNomiProdotto={listaNomiProdotto}
      temaColori={temaColori}
      mobile={mobile}
    />
  );

  const areaCheckSparati = (
    <AreaCheckSparati
      /* magazzino="Prato Nevoso" */
      vistaINIT="checkSparati"
      autenticazione={autenticazione}
      objRicercheRapideDBOrdini={objRicercheRapideDBOrdini}
      temaColori={temaColori}
      inputVuoto={inputVuoto}
      mobile={mobile}
      magCheck={magCheck}
      setMagCheck={setMagCheck}
    />
  );

  let home;

  switch (autenticazione.home) {
    case "ordini":
      home = areaOrdini;
      break;
    case "dashboardOrdini":
      home = dashboardOrdini;
      break;
    case "DashboardDAM":
      home = <DashboardDAM utente={autenticazione} />;
      break;
    case "pubblicazione":
      home = areaPubblicazione;
      break;
    case "check sparati":
      home = areaCheckSparati;
      break;
    case "nuovoUtente":
      home = <HomeNuovoUtente autenticazione={autenticazione} />;
      break;
    case "prodottiConsultazione":
      home = areaPubblicazioneConsultazione;
      break;
    default:
      home = <HomeNuovoUtente autenticazione={autenticazione} />;
      break;
  }

  if (mobile) {
    home = (
      <MenuMobile autenticazione={autenticazione} temaColori={temaColori} />
    );
  }

  ///////////// PAGINA /////////////////

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout
            autenticazione={autenticazione}
            temaColori={temaColori}
            mobile={mobile}
          />
        }
      >
        <Route path="/" element={home} />
        {/* <Route path="/" element={<div className="flex flex-wrap">
          <pre className='w-50'>{JSON.stringify(autenticazione, null, 2)}</pre>
          </div>} /> */}
        <Route
          path="caricacsv"
          element={
            <AreaCSVupload
              utente={autenticazione}
              temaColori={temaColori}
              mobile={mobile}
            />
          }
        />
        <Route
          path="schedaProdottoNEW"
          element={areaPubblicazioneConsultazione}
        />
        <Route
          path="syncimmagini"
          element={<SyncImmagini utente={autenticazione} token={token} />}
        />
        <Route
          path="DBconTraduzioniERicicla"
          element={
            <DBconTraduzioniERicicla
              product={traduzione.prodottoCorrente}
              setProductFunction={setProductFunction}
              utente={autenticazione}
              tradPermessa={tradPermessa}
              setTradPermessa={setTradPermessa}
              charCount={charCount}
              setCharCount={setCharCount}
              temaColori={temaColori}
              mobile={mobile}
            />
          }
        />
        <Route
          path="DBconSchedaProd"
          element={
            <DBconSchedaProd
              mobile={mobile}
              product={traduzione.prodottoCorrente}
              setProductFunction={setProductFunction}
              utente={autenticazione}
              tradPermessa={tradPermessa}
              charCount={charCount}
              charLimit={charLimit}
              charCountLoading={charCountLoading}
              charCountError={charCountError}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="problemiPS"
          element={
            <AreaProblemiPS
              mobile={mobile}
              listaNomiProdotto={listaNomiProdotto}
              product={traduzione.prodottoCorrente}
              setProductFunction={setProductFunction}
              utente={autenticazione}
              tradPermessa={tradPermessa}
              charCount={charCount}
            />
          }
        />

        <Route
          path="problemiDB"
          element={
            <AreaproblemiDB
              mobile={mobile}
              listaNomiProdotto={listaNomiProdotto}
              product={traduzione.prodottoCorrente}
              setProductFunction={setProductFunction}
              utente={autenticazione}
              tradPermessa={tradPermessa}
              charCount={charCount}
            />
          }
        />
        <Route
          path="AreaTraduzioniFromPS"
          element={
            <AreaTraduzioniFromPS
              product={traduzione.prodottoCorrente}
              setProductFunction={setProductFunction}
              utente={autenticazione}
              tradPermessa={tradPermessa}
              setTradPermessa={setTradPermessa}
              charCount={charCount}
              setCharCount={setCharCount}
              listaNomiProdotto={listaNomiProdotto}
              mobile={mobile}
            />
          }
        />
        <Route
          path="AreaAnteprimaExport"
          element={
            <AreaAnteprimaExport
              product={traduzione.prodottoCorrente}
              setProductFunction={setProductFunction}
              utente={autenticazione}
              tradPermessa={tradPermessa}
              setTradPermessa={setTradPermessa}
              charCount={charCount}
              setCharCount={setCharCount}
              listaNomiProdotto={listaNomiProdotto}
              mobile={mobile}
            />
          }
        />
        <Route
          path="psTools"
          element={
            <MenuPStools
              temaColori={temaColori}
              mobile={mobile}
              utente={autenticazione}
            />
          }
        />
        <Route path="htmlCamp" element={<CreaHTMLCampagne />} />
        <Route
          path="ModificaMassivaDatoUlteriore"
          element={
            <ModificaMassivaDatiConSync
              mobile={mobile}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="rimozioneMassivaCategorieDB"
          element={
            <RimozioneMassivaCategorieDB
              mobile={mobile}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="aggiuntaMassivaCategorieDB"
          element={
            <AggiuntaMassivaCategorieDB
              mobile={mobile}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="traduzioni"
          element={<TraduzioniPage utente={autenticazione} />}
        />
        <Route
          path="jobMassiviPubblicazione"
          element={
            <ModaBulkJobsPage
              token={token}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="consultazione"
          element={<Consultazione mobile={mobile} utente={autenticazione} />}
        />
        <Route
          path="dbTools"
          element={<DBToolsMenu mobile={mobile} temaColori={temaColori} />}
        />
        <Route
          path="eanToCodvs"
          element={<EanToCodvsPage utente={autenticazione} />}
        />
        <Route
          path="pubbweek"
          element={<PubbWeekManual temaColori={temaColori} />}
        />
        <Route
          path="correggiUtenti"
          element={<CorreggiUtenti mobile={mobile} temaColori={temaColori} />}
        />
        <Route
          path="stampaOrdini"
          element={
            <RoutineMattutina
              mobile={mobile}
              temaColori={temaColori}
              utente={autenticazione}
            />
          }
        />
        <Route path="controlloMagazzino" element={<ControlloMagazzino utente={autenticazione} />} />
        <Route path="dashboardOrdini" element={dashboardOrdini} />
        <Route
          path="NuovaUIPubblicazione"
          element={<Navigate to="/uiPubblicazione" replace />}
        />
        <Route
          path="uiPubblicazione"
          element={
            <ModaArticoliWorkspace
              token={token}
              utente={autenticazione}
              mobile={mobile}
              temaColori={temaColori}
              setProductFunction={setProductFunction}
              listaNomiProdotto={listaNomiProdotto}
            />
          }
        />
        <Route
          path="matchBottero"
          element={<MatchBotteroPage token={token} utente={autenticazione} />}
        />
        <Route
          path="vediMatchBsVs"
          element={<MatchBotteroReadOnlyPage token={token} />}
        />
        <Route
          path="statsMatchBottero"
          element={<MatchBotteroStatsPage token={token} />}
        />
        <Route
          path="vediMatchVsBs"
          element={<MatchBotteroVsSidePage token={token} />}
        />
        <Route
          path="dashboardPubblicazioni"
          element={
            <DashboardPubblicazioni token={token} temaColori={temaColori} />
          }
        />
        <Route
          path="allineamentoPrestashop"
          element={<PrestashopAlignmentPage token={token} utente={autenticazione} />}
        />
        <Route
          path="prioritaBrand"
          element={
            <PrioritaBrandPage
              token={token}
              utente={autenticazione}
              mobile={mobile}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="statsPubblBrand"
          element={
            <StatsPubblBrandPage
              token={token}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="categorieWebPS"
          element={
            <PrestashopCategoriesPage
              token={token}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="categorieWebMap"
          element={
            <WebCategoryAttributeRulesPage
              token={token}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="valoriDaMappare"
          element={
            <WebCategoryMappingValuesPage
              token={token}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="categorieWebRegole"
          element={
            <WebCategoryAttributeRulesPage
              token={token}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />

        {/* /////////////////         AREE ORDINI       ////////////////////////////// */}

        <Route path="dbOrdini" element={areaOrdini} />
        <Route
          path="ordine/:idOrdineDB"
          element={
            <AreaOrdiniPRE
              vistaINIT="ordini"
              utente={autenticazione}
              ricercaIniz={objRicercheRapideDBOrdini.tutti}
              tema={temaColori}
              urlRicercaINIT={
                apiUrl + "/logistica/ricerca/ricercaOrdiniDBavanzataPagination/"
              }
              perPageINIT={200}
              inputVuoto={inputVuoto}
              keyArea="1"
              mobile={mobile}
            />
          }
        />

        {/* /////////////////        AREE CONTABILITA'       ////////////////////////////// */}

        <Route
          path="pagamenti"
          element={
            <AreaOrdiniPRE
              vistaINIT="contabili"
              utente={autenticazione}
              ricercaIniz={objRicercheRapideContabili.tutti}
              tema={temaColori}
              urlRicercaINIT={apiUrl + "/contab/get/pagamentiRangeDataOrdini/"}
              perPageINIT={15}
              inputVuoto={inputVuoto}
              keyArea="9"
              mobile={mobile}
            />
          }
        />

        <Route
          path="rimborsi"
          element={
            <AreaOrdiniPRE
              vistaINIT="contabiliRimborsi"
              utente={autenticazione}
              ricercaIniz={objRicercheRapideContabili.tutti}
              tema={temaColori}
              urlRicercaINIT={
                apiUrl + "/contab/get/rimborsiRangeDataMovimenti/"
              }
              perPageINIT={15}
              inputVuoto={inputVuoto}
              keyArea="15"
              mobile={mobile}
            />
          }
        />

        {/* /////////////////        AREE CHECK SPARATI       ////////////////////////////// */}
        <Route
          path="controlliCorrispettivi"
          element={
            <ControlliCorrispettivi token={token} />
          }
        />

        <Route
          path="transazioniDominoCorrispettivi"
          element={<TransazioniDominoCorrispettivi token={token} />}
        />

        <Route
          path="riepilogoCorrispettiviConfermati"
          element={
            <RiepilogoCorrispettiviConfermati token={token} />
          }
        />

        <Route
          path="controlloCorrispettiviAmazon"
          element={
            <ControlloCorrispettiviAmazon
              token={token}
              utente={autenticazione}
              temaColori={temaColori}
              mobile={mobile}
            />
          }
        />

        <Route
          path="controlloCorrispettiviPrestashop"
          element={
            <ControlloCorrispettiviPrestashop
              token={token}
              utente={autenticazione}
              temaColori={temaColori}
              mobile={mobile}
            />
          }
        />

        <Route
          path="controlloCorrispettiviGestionale"
          element={
            <ControlloCorrispettiviGestionale
              token={token}
              utente={autenticazione}
              temaColori={temaColori}
              mobile={mobile}
            />
          }
        />


        <Route path="checkSparati" element={areaCheckSparati} />

        <Route
          path="corrispettiviMese"
          element={
            <div className="flex flex-wrap justify-center sfondoBiancoTema">
              <div className="w-third pl2 pr2 br bordoColAlt">
                <ContainerBarraELista
                  query="corrispettiviMese"
                  titolo="Corrispettivi"
                  input={inputCont}
                  setInput={setInputCont}
                  charts={true}
                  mobile={mobile}
                />
              </div>
              <div className="w-third pl2 pr2 br bordoColAlt">
                <ContainerBarraELista
                  query="corrispettiviMeseRimborsi"
                  titolo="Rimborsi"
                  input={inputCont}
                  setInput={setInputCont}
                  charts={true}
                  mobile={mobile}
                />
              </div>
              <div className="w-third pl2 pr2">
                <ContainerBarraELista
                  query="corrispettiviTipoArticoli"
                  titolo="Tipologia articoli (MEMO: UPDATE TABELLE CATEGORIE)"
                  input={inputCont}
                  setInput={setInputCont}
                  charts={false}
                  mobile={mobile}
                />
              </div>
            </div>
          }
        />

        <Route
          path="logisticaBeta"
          element={
            <AreaLogisticaBeta
              mobile={mobile}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="sparaTrovati"
          element={
            <AreaSparaTrovati
              mobile={mobile}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="logisticaOffline"
          element={
            <AreaLogisticaOffline
              mobile={mobile}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="exportCSV"
          element={<ExportCSV mobile={mobile} temaColori={temaColori} />}
        />
        <Route
          path="anagraficheLogistica"
          element={
            <AnaLogistica
              mobile={mobile}
              utente={autenticazione}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="modificheUtenti"
          element={
            <UIultimeModificheOCrea
              utente={autenticazione}
              setProductFunction={setProductFunction}
              product={traduzione.prodottoCorrente}
              tradPermessa={tradPermessa}
              listaNomiProdotto={listaNomiProdotto}
              mobile={mobile}
              temaColori={temaColori}
            />
          }
        />
        <Route
          path="AreaDashboard"
          element={
            <AreaDashboard
              mobile={mobile}
              tema={temaColori}
              listaNomiProdotto={listaNomiProdotto}
              product={traduzione.prodottoCorrente}
              setProductFunction={setProductFunction}
              utente={autenticazione}
              tradPermessa={tradPermessa}
              charCount={charCount}
            />
          }
        />
        <Route
          path="dashboardImmagini"
          element={<DashboardImmaginiJobsPage token={token} />}
        />
        <Route path="dashboardR2Immagini" element={<R2ImagesDashboardPage />} />
        <Route
          path="impostazioni"
          element={
            <Impostazioni
              temaColori={temaColori}
              setTemaColori={setTemaColori}
              autenticazione={autenticazione}
              mobile={mobile}
            />
          }
        />
        <Route path="mag_inventario" element={<Inventario mobile={mobile} />} />
        <Route
          path="status"
          element={<DashboardDAM utente={autenticazione} mobile={mobile} />}
        />
        <Route
          path="statsSpedAnni"
          element={
            <StatSpedAnni
              mobile={mobile}
              input={inputCont}
              setInput={setInputCont}
            />
          }
        />
        <Route
          path="statsSPedCorrieri"
          element={<StatSpedCorrieri mobile={mobile} />}
        />
        <Route
          path="statsSpedMarketplaces"
          element={<StatSpedMarketplaces mobile={mobile} />}
        />
        <Route
          path="StatSpedAnnullati"
          element={
            <StatSpedMotiviAnnullamenti mobile={mobile} tema={temaColori} />
          }
        />
        <Route
          path="header-message"
          element={<HeaderMessageMaintenancePage utente={autenticazione} />}
        />
        <Route
          path="debug-variabili"
          element={<EnvironmentVariablesPage utente={autenticazione} />}
        />
        <Route
          path="variabili-ambiente"
          element={<EnvironmentVariablesPage utente={autenticazione} />}
        />
        <Route path="configurazione-logistica" element={<LogisticaConfigurationPage utente={autenticazione} />} />
        <Route
          path="regole-automatismi-logistica"
          element={<LogisticaAutomationRulesPage utente={autenticazione} />}
        />
        <Route
          path="ui-components"
          element={<UIComponentsPage utente={autenticazione} />}
        />
        <Route
          path="ui-components-skeleton"
          element={<UISkeletonDocsPage utente={autenticazione} />}
        />
      </Route>
    </Routes>
  );
}

export default function ConfiguredApp(props) {
  return <LogisticaConfigurationProvider utente={props.autenticazione}><App {...props} /></LogisticaConfigurationProvider>;
}
